/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
    GDPRConsentResponseToJSONTyped,
} from './GDPRConsentResponse';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PutConsentGdpr200Response
 */
export interface PutConsentGdpr200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PutConsentGdpr200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PutConsentGdpr200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof PutConsentGdpr200Response
     */
    result: GDPRConsentResponse;
}

/**
 * Check if a given object implements the PutConsentGdpr200Response interface.
 */
export function instanceOfPutConsentGdpr200Response(value: object): value is PutConsentGdpr200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function PutConsentGdpr200ResponseFromJSON(json: any): PutConsentGdpr200Response {
    return PutConsentGdpr200ResponseFromJSONTyped(json, false);
}

export function PutConsentGdpr200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutConsentGdpr200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GDPRConsentResponseFromJSON(json['result']),
    };
}

export function PutConsentGdpr200ResponseToJSON(json: any): PutConsentGdpr200Response {
    return PutConsentGdpr200ResponseToJSONTyped(json, false);
}

export function PutConsentGdpr200ResponseToJSONTyped(value?: PutConsentGdpr200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': GDPRConsentResponseToJSON(value['result']),
    };
}

